import { sentenceCase } from 'change-case';
import cs from 'classnames';
import React from 'react';
import { ErrorType } from 'shared/generated.graphql';
import { MutationErrorArray } from 'shared/utils/mutations';


export interface Props {
  field?: string;
  fields?: string[];
  data?: { [key: string]: any } | null;
  value?: any;
  label?: string;
  error?: ErrorType | null;
  errors?: MutationErrorArray | null;
  optional?: boolean;
  uppercase?: boolean;
}

export const SummaryField = ({data, field, fields, value, label, error, errors, optional, uppercase}: Props) => {
  if (fields && fields.length > 0) {
    field = field || fields[0];
    value = value || fields.map(f => data?.[f ?? '']).join(' ');
    error = (errors?.filter((e) => e?.field && e?.messages && fields.includes(e?.field || '')) as ErrorType[])
      .reduce<ErrorType | null>((e, c) => {
        if (c.messages.length > 0) {
          return {
            field: '',
            messages: e?.messages ?? c.messages,
          }
        }
        return e;
      }, null);
  }

  label = label ?? sentenceCase(field ?? '');
  value = value ?? data?.[field ?? ''];
  if (uppercase && typeof value === 'string') {
    value = value.toLocaleUpperCase();
  }
  optional = optional ?? false;
  const e = error ?? errors?.find((e) => e?.field === field);
  if (optional && !value && !error) return null;

  return (
    <>
      <div className={cs(e && 'text-danger is-invalid')}>
        {label ? `${label}:` : null} {value}
      </div>

      {e && (
        <div className='invalid-feedback mt-0 mb-2'>{e.messages.map((m) => (
          <>{m}<br/></>
        ))}</div>
      )}
    </>
  );
};

